<script setup lang="ts">
import SvgIcon from "@/components/ui/SvgIcon/SvgIcon.vue";
import type { FieldChange } from "@/model/change";

import LinkedCard from "./LinkedCard.vue";

defineProps<{ field: FieldChange<string>; showArrow?: boolean }>();
</script>

<template>
  <div class="change horizontal no-wrap">
    <LinkedCard v-if="field?.old" :sticky-id="field?.old" />
    <SvgIcon
      v-if="showArrow"
      name="arrow/right"
      width="20"
      height="20"
      role="img"
      :aria-label="$t('label.cardDiff.changedTo')"
    />
    <LinkedCard v-if="field?.new" :sticky-id="field?.new" />
  </div>
</template>
